import fetchFactory from '../../../utils/fetchFactory'
import { configEnum } from '../../../enum/fetchFactoryEnum'

export const updateDocumentLastCheck = () => fetchFactory('/api/last/check/document',
	{
		method: configEnum.post
	}
)
